import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ShieldCheck } from "lucide-react";
import axios from "axios";
import { setAdminToken, API } from "../lib/adminApi";
import { toast } from "sonner";

export default function AdminLogin() {
  const [pw, setPw] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { password: pw });
      setAdminToken(res.data.token);
      toast.success("Accesso effettuato");
      navigate("/albertoadimpannello/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail || err.message;
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg p-6 grain-bg" data-testid="admin-login">
      <form onSubmit={submit} className="w-full max-w-md card-tactile p-8 md:p-10 relative">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-2xl bg-brand-terracotta text-white flex items-center justify-center heading-display text-lg font-bold">EM</div>
          <div>
            <div className="eyebrow">Pannello Admin</div>
            <div className="heading-display text-xl mt-1">Edil Murgia · MurgiAI</div>
          </div>
        </div>
        <div className="mt-8">
          <label className="text-sm font-semibold text-brand-ink">Password</label>
          <div className="relative mt-2">
            <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-brand-mute" />
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              placeholder="••••••••"
              autoFocus
              className="w-full rounded-full border border-brand-line bg-white pl-10 pr-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-terracotta/30 focus:border-brand-terracotta"
              data-testid="admin-password"
            />
          </div>
        </div>
        <button type="submit" disabled={loading || !pw} className="btn-primary w-full justify-center mt-6" data-testid="admin-login-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />}
          {loading ? "Verifica..." : "Accedi"}
        </button>
        <p className="mt-6 text-xs text-brand-mute text-center">Area riservata. Accessi monitorati.</p>
      </form>
    </div>
  );
}
